import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
  ChangeDetectionStrategy
} from '@angular/core';
import { ConversationItem, Paging } from '@cpd-app/core-module/models';

@Component({
  selector: 'cpd-conversations',
  // ANALYTICS.25: clicks here are counted without their labels, because
  // conversation titles are drawn from what the learner asked Via.
  host: { 'data-track-private': '' },
  templateUrl: './conversations.component.html',
  styleUrls: ['./conversations.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConversationsComponent {
  @ViewChild('messageContent')
  public messageContent: ElementRef<HTMLDivElement>;

  @Input() public conversations: ConversationItem[] = [];
  @Input() public expanded = false;
  @Input() public conversationsLoading = false;
  @Input() public conversationsCount = 20;
  @Input() public conversationsLimit = 10;
  @Input() public conversationsOffset = 0;

  @Output() public back = new EventEmitter<void>();
  @Output() public conversationSelect = new EventEmitter<number>();
  @Output() public deleteConversation = new EventEmitter<number>();
  @Output() public loadMore = new EventEmitter<{
    limit: number;
    offset: number;
  }>();

  public today = new Date().toISOString().split('T')[0];

  public onBackClick(): void {
    this.back.emit();
  }

  public onConversationSelect(conversationId: number): void {
    this.conversationSelect.emit(conversationId);
  }

  public onDeleteConversation(conversationId: number): void {
    this.deleteConversation.emit(conversationId);
  }

  public onNext(paging: Paging): void {
    this.loadMore.emit(paging);
  }
}
